import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter } from '../../../adapter/Adapter.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SaveBoostInputjajsjdtwe7t7 as SaveBoostInput } from '../SaveBoostInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SaveBoostInput_InputAdapterClass;
function SaveBoostInput_InputAdapter() {
  if (SaveBoostInput_InputAdapterClass === VOID) {
    class $ {
      p40(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      t6x(writer, customScalarAdapters, value) {
        writer.l4d('partyId');
        get_partyIdAdapter().q40(writer, customScalarAdapters, value.p6v_1);
      }
      q40(writer, customScalarAdapters, value) {
        return this.t6x(writer, customScalarAdapters, value instanceof SaveBoostInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SaveBoostInput_InputAdapter', VOID, VOID, [Adapter()]);
    SaveBoostInput_InputAdapterClass = $;
  }
  return SaveBoostInput_InputAdapterClass;
}
var SaveBoostInput_InputAdapter_instance;
function SaveBoostInput_InputAdapter_getInstance() {
  return SaveBoostInput_InputAdapter_instance;
}
//region block: init
SaveBoostInput_InputAdapter_instance = new (SaveBoostInput_InputAdapter())();
//endregion
//region block: exports
export {
  SaveBoostInput_InputAdapter_instance as SaveBoostInput_InputAdapter_instance21i6xmkt5f8zc,
};
//endregion

//# sourceMappingURL=SaveBoostInput_InputAdapter.mjs.map
